import React from "react";
import * as IoIcons from "react-icons/io";
import * as AiIcons from "react-icons/ai";
import * as RiIcons from "react-icons/ri";
//import { Auth, API, Storage } from "aws-amplify";
import { getUrl } from "@aws-amplify/storage";
import { GetUsuarios } from "../queries/Queries";

export async function SidebarData(usuarioNombre) {
  //Obtiene los datos de los usuarios

  var apiData = await GetUsuarios({ activo: { eq: true } });
  //const apiData = await API.graphql({ query: listUsuarios, variables: { limit: 100000000 } });
  const usuariosFromAPI = apiData.filter(
    (usuario) => usuario.usuario.toUpperCase() === usuarioNombre
  );
  await Promise.all(
    usuariosFromAPI.map(async (usuario) => {
      if (usuario.image) {
        const image = await getUrl({ key: usuario.image });//await Storage.get(usuario.image);
        usuario.imagename = usuario.image;
        usuario.image = image.url.toString();;
      }
      if (
        usuario.TicketsSoporte ||
        usuario.TicketsUsuarios ||
        usuario.TicketsAuditor
      )
        usuario.Tickets = true;
      else usuario.Tickets = false;

      if (
        usuario.Planeacion === true ||
        usuario.verPlaneacion === true
      )
        usuario.Planeaciones = true;
      else usuario.Planeaciones = false;

      if (
        usuario.PProduccion === true ||
        usuario.Produccion === true ||
        usuario.ProduccionInspeccion === true ||
        usuario.verPlanProduccion === true
      )
        usuario.Producciones = true;
      else usuario.Producciones = false;

      if (
        usuario.Cuarentena === true ||
        usuario.Incoming === true ||
        usuario.ProduccionCalidad ||
        usuario.ProduccionRecuperacion
      )
        usuario.Calidad = true;
      else usuario.Calidad = false;

      if (
        usuario.PProduccionAutNoFIFO1 === true ||
        usuario.PProduccionAutNoFIFO2 === true ||
        usuario.PlaneacionAutNoFIFO === true ||
        usuario.AutorizarTodo === true
      )
        usuario.Autorizaciones = true;
      else usuario.Autorizaciones = false;
      return usuario;
    })
  );

  const usuario = (await usuariosFromAPI[0]) ? usuariosFromAPI[0] : {};

  return [
    {
      title: "Administrar",
      path: "/administrar",
      icon: <RiIcons.RiAdminFill />,
      cName: "nav-text",
      mostrar: usuario.Administrar ? usuario.Administrar : false,
    },
    {
      title: "Métricas",
      path: "/metricas",
      icon: <IoIcons.IoIosStats />,
      cName: "nav-text",
      mostrar: usuario.Metricas ? usuario.Metricas : false,
    },
    {
      title: "Calidad",
      path: "/calidad",
      icon: <IoIcons.IoIosAperture />,
      cName: "nav-text",
      mostrar: usuario.Calidad ? usuario.Calidad : false,
    },
    {
      title: "Clientes",
      path: "/clientes",
      icon: <IoIcons.IoMdPeople />,
      cName: "nav-text",
      mostrar: usuario.Clientes ? usuario.Clientes : false,
    },
    {
      title: "Cotizaciones",
      path: "/cotizaciones",
      icon: <IoIcons.IoIosCash />,
      cName: "nav-text",
      mostrar: usuario.Cotizaciones ? usuario.Cotizaciones : false,
    },
    {
      title: "Productos",
      path: "/productos",
      icon: <IoIcons.IoMdCog />,
      cName: "nav-text",
      mostrar: usuario.Productos ? usuario.Productos : false,
    },
    {
      title: "Reciba",
      path: "/reciba",
      icon: <IoIcons.IoMdClipboard />,
      cName: "nav-text",
      mostrar: usuario.Reciba ? usuario.Reciba : false,
    },
    {
      title: "Almacén",
      path: "/almacen",
      icon: <IoIcons.IoMdFiling />,
      cName: "nav-text",
      mostrar: usuario.Almacen ? usuario.Almacen : false,
    },
    {
      title: "Ubicación del material",
      path: "/ubicacion",
      icon: <IoIcons.IoIosArchive />,
      cName: "nav-text",
      mostrar: usuario.Ubicacion ? usuario.Ubicacion : false,
    },
    {
      title: "Planeación",
      path: "/planeacion",
      icon: <IoIcons.IoIosPaper />,
      cName: "nav-text",
      mostrar: usuario.Planeaciones ? usuario.Planeaciones : false,
    },
    {
      title: "Planeación base",
      path: "/planeacionb",
      icon: <IoIcons.IoIosBookmarks />,
      cName: "nav-text",
      mostrar: usuario.verPlaneacionBase ? usuario.verPlaneacionBase : false,
    },
    {
      title: "Producción",
      path: "/pproduccion",
      icon: <IoIcons.IoIosBusiness />,
      cName: "nav-text",
      mostrar: usuario.Producciones ? usuario.Producciones : false,
    },
    {
      title: "Embarques",
      path: "/embarques",
      icon: <IoIcons.IoIosBus />,
      cName: "nav-text",
      mostrar: usuario.Embarques ? usuario.Embarques : false,
    },
    {
      title: "Facturación",
      path: "/facturacion",
      icon: <IoIcons.IoMdCard />,
      cName: "nav-text",
      mostrar: usuario.Facturacion ? usuario.Facturacion : false,
    },
    {
      title: "Compras",
      path: "/compras",
      icon: <IoIcons.IoMdCart />,
      cName: "nav-text",
      mostrar: usuario.Compras ? usuario.Compras : false,
    },
    {
      title: "Atención a usuarios",
      path: "/tickets",
      icon: <AiIcons.AiOutlineMessage />,
      cName: "nav-text",
      mostrar: usuario.Tickets ? usuario.Tickets : false,
    },
    {
      title: "Usuarios",
      path: "/usuarios",
      icon: <IoIcons.IoIosContacts />,
      cName: "nav-text",
      mostrar: usuario.Usuarios ? usuario.Usuarios : false,
    },
    {
      title: "Cerrar sesión",
      path: "/Login",
      icon: <IoIcons.IoMdClose />,
      cName: "nav-text",
      mostrar: true,
    },
  ];
}
